<template>
  <div class="container">

        <div class="div-top">
            <div class="div-search-box">
                <img class="img-search" src="/images/ic_search.png"/> 
                <input type="text" class="input-search" placeholder="ค้นหา" />
            </div>
        </div>

        <div class="div-center">
            <a href="/chat">
                <div class="div-chat-list-item">
                    <img class="img-fortune" src="/images/fortune_1.png"/>
                    <div class="div-container-message">
                        <label class="label-fortune-name">
                            “หมอวั้ง”
                        </label>
                        <label class="label-last-message">
                            “หมอวั้ง” วรางคณา อัชชะกิจ ครับผม “หมอวั้ง” วรางคณา อัชชะกิจ ครับผม “หมอวั้ง” วรางคณา อัชชะกิจ ครับผม “หมอวั้ง” วรางคณา อัชชะกิจ ครับผม “หมอวั้ง” วรางคณา อัชชะกิจ ครับผม “หมอวั้ง” วรางคณา อัชชะกิจ ครับผม “หมอวั้ง” วรางคณา อัชชะกิจ ครับผม “หมอวั้ง” วรางคณา อัชชะกิจ ครับผม “หมอวั้ง” วรางคณา อัชชะกิจ ครับผม “หมอวั้ง” วรางคณา อัชชะกิจ ครับผม “หมอวั้ง” วรางคณา อัชชะกิจ ครับผม “หมอวั้ง” วรางคณา อัชชะกิจ ครับผม
                        </label>
                    </div>
                    <div class="div-container-date">
                        <label class="label-updated-date">
                            วันนี้ 12:45
                        </label>
                        <div class="div-unread-count">
                            <label class="label-unread-count">
                                5
                            </label>
                        </div>
                    </div>
                </div>
            </a>
    
            <a href="/chat">
                <div class="div-chat-list-item">
                    <img class="img-fortune" src="/images/fortune_2.png"/>
                    <div class="div-container-message">
                        <label class="label-fortune-name">
                            เนม วิวัฒน์
                        </label>
                        <label class="label-last-message">
                            หมอเนมมีประสบการณ์ในวงการโหราศาตร์
                        </label>
                    </div>
                    <div class="div-container-date">
                        <label class="label-updated-date">
                            วันนี้ 10:00
                        </label>
                        <div class="div-unread-count">
                            <label class="label-unread-count">
                                3
                            </label>
                        </div>
                    </div>
                </div>
            </a>
            
            <a href="/chat">
                <div class="div-chat-list-item">
                    <img class="img-fortune" src="/images/fortune_3.png"/>
                    <div class="div-container-message">
                        <label class="label-fortune-name">
                            อ.แพธ อาทิชา (ลูกแก้วเทพเจ้าไอยคุปต์)
                        </label>
                        <label class="label-last-message">
                            หมอเนมมีประสบการณ์ในวงการโหราศาตร์
                        </label>
                    </div>
                    <div class="div-container-date">
                        <label class="label-updated-date">
                            วันนี้ 10:00
                        </label>
                        <div class="div-unread-count">
                            <label class="label-unread-count">
                                1
                            </label>
                        </div>
                    </div>
                </div>
            </a>
            
        </div>
    </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
